import React from "react";
import "./HTML_MAIN_CSS.css";

const HTML_Examples = () => {
  return (
    <div className="html-container">
      <h1>HTML Examples</h1>

      {/* 1. Basic HTML Structure */}
      <section className="html-section">
        <h2>1. Basic HTML Structure</h2>
        <pre className="code-block">
          <code>{`<!DOCTYPE html>
<html>
  <head>
    <title>My First Page</title>
  </head>
  <body>
    <h1>Hello, World!</h1>
    <p>This is my first HTML page.</p>
  </body>
</html>`}</code>
        </pre>
      </section>

      {/* 2. HTML Headings */}
      <section className="html-section">
        <h2>2. HTML Headings</h2>
        <pre className="code-block">
          <code>{`<h1>Main Heading</h1>
<h2>Subheading</h2>
<h3>Section Heading</h3>
<h4>Smaller Heading</h4>
<h5>Even Smaller</h5>
<h6>Smallest Heading</h6>`}</code>
        </pre>
      </section>

      {/* 3. HTML Paragraphs */}
      <section className="html-section">
        <h2>3. HTML Paragraphs</h2>
        <pre className="code-block">
          <code>{`<p>This is a paragraph of text.</p>
<p>Another paragraph with <strong>bold</strong> and <em>italic</em> text.</p>`}</code>
        </pre>
      </section>

      {/* 4. HTML Links */}
      <section className="html-section">
        <h2>4. HTML Links</h2>
        <pre className="code-block">
          <code>{`<a href="https://www.example.com">Visit Example.com</a>
<a href="#section2">Go to Section 2</a>`}</code>
        </pre>
      </section>

      {/* 5. HTML Images */}
      <section className="html-section">
        <h2>5. HTML Images</h2>
        <pre className="code-block">
          <code>{`<img src="image.jpg" alt="Description of image" width="300" height="200">
<img src="logo.png" alt="Company Logo">`}</code>
        </pre>
      </section>

      {/* 6. HTML Lists */}
      <section className="html-section">
        <h2>6. HTML Lists</h2>
        <pre className="code-block">
          <code>{`<!-- Ordered List -->
<ol>
  <li>First item</li>
  <li>Second item</li>
</ol>

<!-- Unordered List -->
<ul>
  <li>Apples</li>
  <li>Oranges</li>
</ul>`}</code>
        </pre>
      </section>

      {/* 7. HTML Tables */}
      <section className="html-section">
        <h2>7. HTML Tables</h2>
        <pre className="code-block">
          <code>{`<table border="1">
  <tr>
    <th>Name</th>
    <th>Age</th>
  </tr>
  <tr>
    <td>John</td>
    <td>25</td>
  </tr>
  <tr>
    <td>Jane</td>
    <td>30</td>
  </tr>
</table>`}</code>
        </pre>
      </section>

      {/* 8. HTML Forms */}
      <section className="html-section">
        <h2>8. HTML Forms</h2>
        <pre className="code-block">
          <code>{`<form action="/submit" method="post">
  <label for="name">Name:</label>
  <input type="text" id="name" name="name"><br><br>
  
  <label for="email">Email:</label>
  <input type="email" id="email" name="email"><br><br>
  
  <input type="submit" value="Submit">
</form>`}</code>
        </pre>
      </section>

      {/* 9. HTML Audio & Video */}
      <section className="html-section">
        <h2>9. HTML Audio & Video</h2>
        <pre className="code-block">
          <code>{`<!-- Audio -->
<audio controls>
  <source src="audio.mp3" type="audio/mpeg">
  Your browser does not support the audio element.
</audio>

<!-- Video -->
<video width="320" height="240" controls>
  <source src="video.mp4" type="video/mp4">
  Your browser does not support the video tag.
</video>`}</code>
        </pre>
      </section>

      {/* 10. HTML Comments */}
      <section className="html-section">
        <h2>10. HTML Comments</h2>
        <pre className="code-block">
          <code>{`<!-- This is a comment -->
<p>This paragraph is visible, but comments are not.</p>`}</code>
        </pre>
      </section>
    </div>
  );
};

export default HTML_Examples;
